<!-- Global in-app push toast -- see notification-toast.component.ts doc for why this lives
     here (mounted once in app.component.html) instead of inside the notification bell. -->
<div
  class="notification-toast"
  *ngIf="state"
  [@toastSlideAnimation]
  [@.disabled]="prefersReducedMotion"
  [class.notification-toast--clickable]="isClickable"
  (click)="onToastClick()"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  role="status"
  aria-live="polite">
  <span class="notification-toast-accent" aria-hidden="true"></span>

  <div class="notification-toast-icon">
    <i class="bi" [ngClass]="state.count > 1 ? 'bi-bell-fill' : 'bi-bell'"></i>
    <span class="notification-toast-count-badge" *ngIf="state.count > 1">{{ state.count }}</span>
  </div>

  <div class="notification-toast-body">
    <div class="notification-toast-eyebrow">{{ eyebrowLabel }}</div>
    <div class="notification-toast-title">{{ headline }}</div>
    <div class="notification-toast-text" *ngIf="subtext">{{ subtext }}</div>
  </div>

  <button type="button" class="notification-toast-close" (click)="onClose($event)" aria-label="Dismiss notification">
    <i class="bi bi-x"></i>
  </button>

  <div class="notification-toast-progress-track" aria-hidden="true">
    <div
      class="notification-toast-progress-bar"
      [style.width.%]="progressWidthPercent"
      [style.transitionDuration.ms]="progressTransitionMs"></div>
  </div>
</div>
